export const contactsMockValues = {
  contacts: [],
};
